import { MODEL_DISPLAY_NAMES } from './model-constants';

export function friendlyModelLabel(raw: string | null | undefined): string | undefined {
  if (!raw) return undefined;
  const known = MODEL_DISPLAY_NAMES[raw] ?? MODEL_DISPLAY_NAMES[raw.replace(/-preview$/, '')];
  if (known) return known;
  return /^(gemini|veo|imagen)/i.test(raw) ? raw : undefined;
}
